import React from "react";

import Editor from './ABridTileEditor'
import EditorWrapper from '../../EditorWrapper'

import BridTile from "../../common/BridTile";
import EmptyArticle from "../../common/EmptyArticle";

const ABridTile = props => {
    let article = EmptyArticle();
    const { settings } = props;
    const imageUrl = (settings['background-image'] ? settings['background-image'] : '');

    article.title = settings.title_normal;
    article.picture.img = window.MEDIA_DOMAIN + '/' + imageUrl.replace('.', ',780,0,0,0.');
    article.url = settings.link;
    article.label = settings.label;
    article.reqAmount = settings.req_amount;
    article.amountCollected = settings.amount_collected;
    article.time = settings.time;
    article.progress = settings.progress;

    // linki dodatkowe
    settings.show_links = (settings.show_links ? settings.show_links : 'off');
    article.show_links = settings.show_links;
    article.links = settings.links;

    // props.onRegisterBox(props.blockId, props.id, 'title_normal')

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridTile article={article} size={props.size} imageHeight={props.imageHeight} preserveImageRatio={props.preserveImageRatio} voteFinished={props.voteFinished} />
        </div>
    );
};

export default ABridTile;
